export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Caramel colorant (Poudre)-c41a487502bf7f35fa394090cc79ca0f.pdf";